import React from 'react';
import { TextInput } from 'chic-ui';
import { Row } from 'react-bootstrap';
import { FaUserAlt } from 'react-icons/fa'

const Icons = () => {
  return (
    <>
      <h4 className="mt-5">Icons</h4>
      <p>
        Use icons within the text input using the <i>icon</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <TextInput className="single-btn" placeholder="Enter Full Name"  icon={FaUserAlt} />
     </div>
      <Row className="mt-3">
        <code>
          {'import { TextInput } from "chic-ui";'}
          <br />
          {'<TextInput placeholder="Type something..." icon={FaUserAlt} />'}
        </code>
      </Row>
    </>
  );
};

export default Icons;
